import React from "react"
import { CustomHeaderLogoWrapper } from "./style.jsx"
import {isApplyCustomLayout} from '../const.js'
import urls from '../../../config/urls.js'
const CustomHeaderLogo = ({children, pathname = ''}) => {
  return <CustomHeaderLogoWrapper pathname={pathname} isApplyCustomLayout={isApplyCustomLayout} target="/blank" href={urls.LOGOURL} />
}

export default CustomHeaderLogo



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomHeaderLogo/index.js